export default "__VITE_ASSET__Bqw3ye$J__"